module.exports = __webpack_public_path__ + "static/media/bi.cf790c09.svg";